import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightPointingAngle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 11,
	viewBox: "0 0 7 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.24268 0.999512L5.48535 5.24219L1.24268 9.48486",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgRightPointingAngle;
